import { c as _c } from "react/compiler-runtime";
import { FilterChipDropdownItem } from "@components/common/faro-table/faro-table-filter/filter-chip-dropdown-item";
import { FilterChipSearch } from "@components/common/faro-table/faro-table-filter/filter-chip-search";
import { getLocationNameFilterId, LOCATION_PART_LABELS } from "@components/projects/projects-filters/projects-location-filter-utils";
import { ChevronLeftIcon, IconButton, MenuItem, MenuSeparator, Text } from "@flat-ui";
import { Stack } from "@mui-wrapper";
import { useState } from "react";
/**
 * The cities or countries to filter the projects by, shown in the dropdown of the location chip.
 * The filter for the projects without one comes first, then the names the user can search.
 */
export function LocationPartList(t0) {
  const $ = _c(36);
  const {
    part,
    names,
    isLoading,
    activeFilterIds,
    onFilterClicked,
    onBack,
    onEscape
  } = t0;
  const [searchText, setSearchText] = useState("");
  const {
    name,
    pluralName,
    noneLabel,
    noneFilterId
  } = LOCATION_PART_LABELS[part];
  let t1;
  if ($[0] !== activeFilterIds || $[1] !== isLoading || $[2] !== name || $[3] !== names || $[4] !== noneFilterId || $[5] !== noneLabel || $[6] !== onBack || $[7] !== onEscape || $[8] !== onFilterClicked || $[9] !== part || $[10] !== pluralName || $[11] !== searchText) {
    const search = searchText.trim().toLowerCase();
    const shownNames = names.filter(locationName => locationName.toLowerCase().includes(search));
    let t2;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = {
        alignItems: "center",
        gap: 0.5,
        px: 1
      };
      $[13] = t2;
    } else {
      t2 = $[13];
    }
    let t3;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <ChevronLeftIcon />;
      $[14] = t3;
    } else {
      t3 = $[14];
    }
    let t4;
    if ($[15] !== onBack) {
      t4 = <IconButton aria-label="Back to the location" size="s" onClick={onBack}>{t3}</IconButton>;
      $[15] = onBack;
      $[16] = t4;
    } else {
      t4 = $[16];
    }
    let t5;
    if ($[17] !== name) {
      t5 = <Text variant="heading14">{name}</Text>;
      $[17] = name;
      $[18] = t5;
    } else {
      t5 = $[18];
    }
    let t6;
    if ($[19] !== t4 || $[20] !== t5) {
      t6 = <Stack direction="row" sx={t2}>{t4}{t5}</Stack>;
      $[19] = t4;
      $[20] = t5;
      $[21] = t6;
    } else {
      t6 = $[21];
    }
    let t7;
    if ($[22] !== onEscape || $[23] !== searchText) {
      t7 = <FilterChipSearch searchText={searchText} setSearchText={setSearchText} onEscape={onEscape} />;
      $[22] = onEscape;
      $[23] = searchText;
      $[24] = t7;
    } else {
      t7 = $[24];
    }
    let t8;
    if ($[25] !== noneFilterId || $[26] !== noneLabel) {
      t8 = {
        id: noneFilterId,
        label: noneLabel
      };
      $[25] = noneFilterId;
      $[26] = noneLabel;
      $[27] = t8;
    } else {
      t8 = $[27];
    }
    let t9;
    if ($[28] !== activeFilterIds || $[29] !== noneFilterId) {
      t9 = activeFilterIds.includes(noneFilterId);
      $[28] = activeFilterIds;
      $[29] = noneFilterId;
      $[30] = t9;
    } else {
      t9 = $[30];
    }
    let t10;
    if ($[31] !== onFilterClicked || $[32] !== t8 || $[33] !== t9) {
      t10 = <FilterChipDropdownItem filterItem={t8} isItemSelected={t9} onItemClicked={onFilterClicked} shouldShowCheckbox={true} shouldShowCheckIconOnRight={false} shouldAllowLabelTranslation={true} />;
      $[31] = onFilterClicked;
      $[32] = t8;
      $[33] = t9;
      $[34] = t10;
    } else {
      t10 = $[34];
    }
    let t11;
    if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = <MenuSeparator />;
      $[35] = t11;
    } else {
      t11 = $[35];
    }
    t1 = <>{t6}{t7}{t10}{t11}{shownNames.length === 0 ? <MenuItem label={isLoading ? `Loading the ${pluralName}...` : `No ${pluralName} found`} sx={{
        pointerEvents: "none",
        textWrap: "wrap"
      }} /> : shownNames.map(locationName_0 => {
        const filterId = getLocationNameFilterId(part, locationName_0);
        return <FilterChipDropdownItem key={filterId} filterItem={{
          id: filterId,
          label: locationName_0
        }} isItemSelected={activeFilterIds.includes(filterId)} onItemClicked={onFilterClicked} shouldShowCheckbox={true} shouldShowCheckIconOnRight={false} />;
      })}</>;
    $[0] = activeFilterIds;
    $[1] = isLoading;
    $[2] = name;
    $[3] = names;
    $[4] = noneFilterId;
    $[5] = noneLabel;
    $[6] = onBack;
    $[7] = onEscape;
    $[8] = onFilterClicked;
    $[9] = part;
    $[10] = pluralName;
    $[11] = searchText;
    $[12] = t1;
  } else {
    t1 = $[12];
  }
  return t1;
}